class YoutubeVideo {
  constructor() {
    this.player = null;
    this.done = false;
  }

  static printBg() {
    document.body.style.background = 'yellow';
  }

  static loadYtIframeApi() {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  embedYouTubePlayer() {
    this.player = new window.YT.Player('webdoor-video', {
      height: '360',
      width: '640',
      videoId: '2dcdjSDymYg',
      playerVars: {
        autoplay: 1,
        controls: 0,
        showinfo: 0,
        rel: 0,
        modestbranding: 0,
        loop: 1,
        playlist: '2dcdjSDymYg',
        disablekb: 1,
      },
      events: {
        onReady: (event) => {
          event.target.mute();
        },
      },
    });
  }
}

export default {
  create() {
    const yt = new YoutubeVideo();
    window.onYouTubeIframeAPIReady = () => {
      yt.embedYouTubePlayer();
    };

    YoutubeVideo.loadYtIframeApi();
    return yt;
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/YoutubeVideo.js